<template>
  <div class="content Tabs">
    
    <b-tabs card v-model="tabIndex">

      <b-tab :title="lang.tab_Details" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        <p v-if="!isAssembly">{{lang.infotext_1}}:</p>
        <PartDetailsComponent v-if="!isAssembly" :lang="lang.PartDetails"></PartDetailsComponent>

        <p v-if="isAssembly">{{lang.infotext_2}}:</p>
        <AssemblyDetailsComponent v-if="isAssembly" :lang="lang.AssemblyDetails"></AssemblyDetailsComponent>

      </b-tab>
      <b-tab :title="lang.tab_History" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 1">
        <!-- <p>{{ lang.infotext_1 }}:</p> -->
        <HistoryDetailsComponent :lang="lang.DetailsHistory" parent="details"></HistoryDetailsComponent>



      </b-tab>
    </b-tabs>

  </div>

</template>
<script>
//import { mapGetters } from 'vuex'

import PartDetailsComponent from '@/components/shared/PartDetailsComponent'
import AssemblyDetailsComponent from '@/components/shared/AssemblyDetailsComponent'
import HistoryDetailsComponent from '@/components/shared/HistoryDetailsComponent'
//import EditPartDetailsComponent from '@/components/shared/EditPartDetailsComponent'

export default {
  name: "Content",
  components: {
    PartDetailsComponent,
    AssemblyDetailsComponent,
    HistoryDetailsComponent
    //EditPartDetailsComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,

    }
  },
  computed: {
    isAssembly() {
      if (this.$store.getters.selectedRows[0] != undefined) {
        if (this.$store.getters.selectedRows.length == 1) {
          return this.$store.getters.selectedRows[0].col___status.assembly == true;
        }
      }
      
      
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }

  },
  created() {
    this.getTabIndex();

  },
  
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
      this.$parent.$parent.$parent.switchButtons(newVal);
    }
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
  },
}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDetails/Middle/Content/Content.vue